import createAllAnnouncementsAtom from './all-announcements.js'
import createShownAnnoucementsAtom from './shown-announcements.js'
import createShownForcedAnnoucementsAtom from './shown-forced-announcements.js'
import createAnnouncementsFilterAtom from './announcements-filters.js'
import createVisibleAnnouncementsAtom from './visible-announcements.js'

export const allAnnouncementsAtomDefinition = {
  id: 'allAnnouncementsAtom',
  type: 'atom',
  factory: createAllAnnouncementsAtom,
  dependencies: [],
  public: true,
}

export const shownAnnouncementsAtomDefinition = {
  id: 'shownAnnouncementsAtom',
  type: 'atom',
  factory: createShownAnnoucementsAtom,
  dependencies: ['storage'],
  public: true,
}

export const shownForcedAnnouncementsAtomDefinition = {
  id: 'shownForcedAnnouncementsAtom',
  type: 'atom',
  factory: createShownForcedAnnoucementsAtom,
  public: true,
}

export const announcementsFiltersAtomDefinition = {
  id: 'announcementsFiltersAtom',
  type: 'atom',
  factory: createAnnouncementsFilterAtom,
  dependencies: [
    'shownAnnouncementsAtom',
    'shownForcedAnnouncementsAtom',
    'backedUpAtom',
    'txLogsAtom',
    'geolocationAtom',
    'balancesAtom',
    'hasBalanceAtom',
    'seedlessAtom?',
    'hasNftsAtom?',
    'config',
    'walletAccountsAtom',
  ],
  public: true,
}

export const visibleAnnouncementsAtomDefinition = {
  id: 'visibleAnnouncementsAtom',
  type: 'atom',
  factory: createVisibleAnnouncementsAtom,
  dependencies: ['allAnnouncementsAtom', 'announcementsFiltersAtom'],
  public: true,
}
